import APIClient from '../services/APIClient';
import { appendInlineParams } from './helper';

class Telemetry {
  findAll = (bodyParams = {}, inlineParams = {}) => APIClient
    .post('/dictionaries/telemetry-metrics/list', bodyParams, inlineParams);

  update = (inlineParams = {}, bodyParams) => APIClient.put(
    appendInlineParams('/dictionaries/telemetry-metrics/:uuid', inlineParams),
    bodyParams,
  );

  create = (bodyParams) => APIClient.post('/dictionaries/telemetry-metrics', bodyParams);
}

export default new Telemetry();
